import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { Field } from 'react-final-form';
import Translate from 'react-translate-component';

import Select from 'components/common/form/Select';
import Input from 'components/common/form/Input';

export default class MassStageFields extends Component {
    static propTypes = {
        menuAction: PropTypes.object,
        isExcluded: PropTypes.bool
    };

    render() {
        const { menuAction, isExcluded } = this.props;

        return <Fragment>
            <Field
                name='idm'
                component={Select}
                options={menuAction.data.menu}
                onChangeTransformer={value => +value}
                dictionaryAction={menuAction}
                placeholder={<Translate content='placeholders.stage' />}
                valuePath='idm'
                label={{
                    content: 'events.stage',
                    required: true
                }} />
            <Field
                name='comment'
                component={Input}
                hidden={!isExcluded}
                label={{ content: 'events.comment', required: true }}
                placeholder='placeholders.comment' />
        </Fragment>
    }
}
